import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

const PrivacyPolicy = () => {
  return (
    <section className="privacy-policy-section py-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={10} lg={8}>
            <Card className="p-4 shadow-sm rounded-3">
              <h2 className="mb-4 text-center brown-text-color">Privacy Policy</h2>
              <p>
                At <strong>Wheat Bakes</strong>, we value your privacy and are
                committed to protecting your personal information. This policy
                outlines how we collect, use, and safeguard the information you
                provide to us.
              </p>

              <h5>1. Information We Collect</h5>
              <p>We collect personal information when you:</p>
              <ul>
                <li>Place an order on our website</li>
                <li>Subscribe to our mailing list</li>
                <li>Interact with us through customer support</li>
              </ul>
              <p>This information may include:</p>
              <ul>
                <li>Name</li>
                <li>Email address</li>
                <li>Shipping address</li>
                <li>Payment details (processed securely)</li>
              </ul>

              <h5>2. How We Use Your Information</h5>
              <ul>
                <li>Process and fulfill orders</li>
                <li>Provide customer support</li>
                <li>
                  Communicate updates, promotions, or important information
                  about Wheat Bakes
                </li>
                <li>Improve our products and services based on your feedback</li>
              </ul>

              <h5>3. Data Security</h5>
              <ul>
                <li>Encrypting sensitive data</li>
                <li>
                  Monitoring our systems regularly to prevent unauthorized
                  access, alteration, or disclosure
                </li>
                <li>Ensuring that only authorized personnel have access</li>
              </ul>

              <h5>4. Third-Party Disclosure</h5>
              <p>
                We do not sell, trade, or share your personal information with
                third parties unless:
              </p>
              <ul>
                <li>It is required by law</li>
                <li>
                  It is necessary to facilitate order fulfillment (e.g., sharing
                  your shipping address with delivery carriers)
                </li>
              </ul>

              <h5>5. Cookies and Tracking</h5>
              <ul>
                <li>Improve your browsing experience</li>
                <li>
                  Collect data on how you interact with our website to enhance
                  functionality
                </li>
              </ul>
              <p>
                You can adjust your browser settings to manage or block cookies
                entirely.
              </p>

              <h5>6. Your Consent</h5>
              <p>By using our website, you consent to our privacy policy.</p>

              <h5>7. Changes to this Privacy Policy</h5>
              <p>
                We may update this policy from time to time. Any changes will be
                reflected on this page with the updated effective date.
              </p>

              <h5>8. Contact Us</h5>
              <p>
                If you have any questions or concerns, please contact us at:
                <br />
                <a href="mailto:wheatbakes.marketing@gmail.com" className="brown-text-color"> 
                  <u>wheatbakes.marketing@gmail.com</u>
                </a>
              </p>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default PrivacyPolicy;
